/**
 * Sitra design tokens (theme sitra-25, sitra.fi), as CSS custom properties.
 *
 * One source, included by GlobalStyles (the app) and .storybook/preview.jsx
 * (the stories), so a component sees the same tokens in both. Components use
 * the semantic aliases (--color-primary, --surface-elevated…), never the
 * named colours, so a palette change is one edit here.
 *
 * The app's screens are dark; the surface aliases at the end are the dark
 * counterparts Sitra's light palette does not define.
 */
export const SITRA_TOKENS = `
  :root {
    --color-blueberry: hsl(209 55% 47%);
    --color-blueberry-light: hsl(209 48% 86%);
    --color-dandelion: hsl(53 100% 50%);
    --color-dandelion-light: hsl(53 100% 75%);
    --color-evergreen: hsl(153 100% 26%);
    --color-evergreen-light: hsl(153 35% 81%);
    --color-kerkka: hsl(93 63% 48%);
    --color-kerkka-light: hsl(93 59% 88%);
    --color-lingonberry: hsl(344 86% 49%);
    --color-lingonberry-light: hsl(344 82% 89%);
    --color-tellus: hsl(194 75% 69%);
    --color-tellus-light: hsl(194 78% 91%);
    --color-tyrni: hsl(31 100% 61%);
    --color-tyrni-light: hsl(31 100% 91%);
    --color-grey-1: #292929;
    --color-grey-2: #636363;
    --color-grey-3: #B8B8B8;
    --color-grey-4: #D9D9D9;
    --color-grey-5: #F2F2F2;
    --color-grey-6: #F7F7F7;

    --color-primary: var(--color-blueberry);
    --color-accent: var(--color-dandelion);
    --color-success: var(--color-evergreen);
    --color-error: var(--color-lingonberry);
    --color-warning: var(--color-tyrni);
    --color-info: var(--color-tellus);
    --color-focus-outline: var(--color-tellus);

    /* Dark surfaces for the app's screens */
    --surface-elevated: hsl(215 40% 10%);
    --surface-border: hsl(215 25% 24%);
    --text-on-dark: #F2F2F2;
    --text-muted-on-dark: #B8B8B8;

    --font-sans: "RationalText", "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", sans-serif;
    --fw-regular: 400;
    --fw-medium: 500;
    --fw-semibold: 600;
    --fw-bold: 700;
    --fs-tag: 0.75rem;
    --fs-label: 0.8rem;
    --fs-body-s: 0.875rem;
    --fs-body: 1rem;
    --fs-button: 1rem;
  }
`;
